import popBeep from '/public/sounds/snapei-pop.mp3';

class SoundPlayer {
    private static instances: { [key: string]: HTMLAudioElement } = {};
    private static initialized: boolean = false;

    private static initialize() {
        if (!this.initialized) {
            this.getInstance(popBeep);
            this.initialized = true;
        }
    }

    private static getInstance(soundPath: string): HTMLAudioElement {
        if (!this.instances[soundPath]) {
            const audio = new Audio(soundPath);
            audio.preload = 'auto'; 
            this.instances[soundPath] = audio;
            audio.load();
        }
        return this.instances[soundPath];
    }

    static async playSound(soundPath: string): Promise<void> {
        this.initialize();
        
        try {
            const audio = this.getInstance(soundPath);            
            if (!audio.paused) {
                audio.pause();
            }
            audio.currentTime = 0;
            await audio.play();
        } catch (error) {
            console.error('Error al reproducir el sonido:', error);
            const audio = this.getInstance(soundPath);
            audio.load();
        }
    }

    // Método específico para el sonido pop
    static async playPop(): Promise<void> {
        return this.playSound(popBeep);
    }
}

export default SoundPlayer;
